import React from 'react';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import './slot_creation.css';
import slotimg from "../../images/free.png"
import Pagination from 'react-js-pagination'; // Make sure to install this library
import dummyimg from '../../images/img/slotdummy.jpg';


const SlotCreation = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [postloading, setPostloading] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    slot_name: "",
    slot_description: "",
    slot_image: null, // Ensure this starts as null for file
    from_time: "",
    to_time: "",
    advance_hrs_for_booking: 0
  });

const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});
const [isEditModalOpen, setEditModalOpen] = useState(false);
const handleEditCategory = (item) => {
  setEditFormData({
    slot_name: item.slot_name,
    slot_description: item.slot_description,
    slot_image: item.slot_image,
    from_time: item.from_time,
    to_time: item.to_time,
    id: item.id,
    shop_id: item.shop_id,
    is_active: item.is_active,
    advance_hrs_for_booking: item.advance_hrs_for_booking
  });
  setEditModalOpen(true); // Open the edit modal
};

const [editFormData, setEditFormData] = useState({
  slot_name: "",
  slot_description: "",
  slot_image: null,
  from_time: "",
  to_time: "",
  id: "",
  is_active:0,
  advance_hrs_for_booking: 0
});
const handleEditInputChange = (e) => {
  const { name, value } = e.target;
  setEditFormData({ ...editFormData, [name]: value });

  if (name === "to_time") {
    const fromTime = editFormData.from_time;
    const toTime = value;

    if (fromTime && toTime && fromTime >= toTime) {
      setEditFormData((prev) => ({ ...prev, to_time: "" }));
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "From Time should be earlier than To Time.",
        confirmButtonText: "OK",
      });
    }
  }
};

const handleEditImageChange = (e) => {
  setEditFormData({ ...editFormData, slot_image: e.target.files[0] });
};

const handleEditSubmit = async (e) => {
  e.preventDefault();

  if (editFormData.from_time >= editFormData.to_time) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "From Time should be earlier than To Time.",
      confirmButtonText: "OK",
    });
    return;
  }
  
  const token=localStorage.getItem('Token');
  // Form data for slot update
  const formData = new FormData();
  formData.append('slot_name', editFormData.slot_name);
  formData.append('slot_description', editFormData.slot_description);
  formData.append('from_time', editFormData.from_time);
  formData.append('to_time', editFormData.to_time);
  formData.append('slot_image', editFormData.slot_image);  // If you have an image
  formData.append('shop_id', editFormData.shop_id);  // Include the ID of the slot to update
  formData.append('is_active', editFormData.is_active);
  formData.append('advance_hrs_for_booking', editFormData.advance_hrs_for_booking);

  try {
    // Sending PUT request to the API
    const response = await axios.put(`${var_api}slot-master/put/${editFormData.id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Important for file uploads
        Authorization:`${token}`
      },
    });

    if (response.status === 200) {
      // Handle successful update
      console.log('Slot updated successfully:', response.data);
      fetchTables();
      Swal.fire("Success", "Slot updated successfully!", "success");

      setEditModalOpen(false); // Close the modal after update
      // Optionally, refresh the slot list or update state
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
    Swal.fire("Error", `${error.response.data.error}`, "error");

    // Handle error (e.g., show a message to the user)
  }
};



console.log(formData)

//change the role
const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5); // Adjust items per page as needed
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTables, setFilteredTables] = useState(tables);

  // Handle search input change
  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter tables based on search query
  useEffect(() => {
    const filtered = tables.filter(item =>
      item.slot_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.slot_description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.from_time.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.to_time.toLowerCase().includes(searchQuery.toLowerCase())


    );
    setFilteredTables(filtered);
  }, [searchQuery, tables]);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTables = filteredTables.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
      }, []);


      const fetchTables = async () => {
        setLoading(true);
        try {
          const token=localStorage.getItem('Token');
          const shop_id=localStorage.getItem('ShopId');

           const response = await axios.get(`${var_api}slot-master/get/${shop_id}`,{
            headers:{
              Authorization: `${token}`, // Pass user token
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          setTables([])
        }
      };
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      const shopCodeOptions = [
        { value: 0, label: 'All' },
        ...shops.map(shop => ({
          value: shop.id,
          label: shop.shop_name
        }))
      ];
      
      

     //search the transaction data
     const filteredSuppliers = tables && tables.filter((order) => {
      const searchLower = searchQuery.toLowerCase();
      return (
        (order.e_name && order.e_name.toString().toLowerCase().includes(searchLower)) ||
        (order.e_email && order.e_email.toString().toLowerCase().includes(searchLower))  ||
        (order.e_phone && order.e_phone.toString().toLowerCase().includes(searchLower))  ||
        (order.e_role && order.e_role.toString().toLowerCase().includes(searchLower)) 
      );
    });

//handle image change

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));

  if (name === "to_time") {
    const fromTime = formData.from_time;
    const toTime = value;

    if (fromTime && toTime && fromTime >= toTime) {
      setFormData((prev) => ({ ...prev, to_time: "" }));
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "From Time should be earlier than To Time.",
        confirmButtonText: "OK",
      });
    }
  }
};

// Handle file input changes
const handleImageChange = (e) => {
  const file = e.target.files[0];
  setFormData((prev) => ({ ...prev, slot_image: file }));
};



 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

   const Submit = async (e) => {
    e.preventDefault();
    if (formData.from_time >= formData.to_time) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "From Time should be earlier than To Time.",
        confirmButtonText: "OK",
      });
      return;
    }
    
    setPostloading(true);
  
    // Prepare form data for API
    const formDataToSend = new FormData();
    formDataToSend.append("slot_name", formData.slot_name);
    formDataToSend.append("slot_description", formData.slot_description);
    formDataToSend.append("slot_image", formData.slot_image);
    formDataToSend.append("is_active", 1); // Example static active status
    formDataToSend.append("from_time", formData.from_time);
    formDataToSend.append("to_time", formData.to_time);
    formDataToSend.append("advance_hrs_for_booking", formData.advance_hrs_for_booking);
    formDataToSend.append("shop_id", 1);

  
    try {
      const token=localStorage.getItem('Token');
      const response = await axios.post(
        `${var_api}slot-master/post`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`, // Pass user token
          },
        }
      );
      console.log("Slot created successfully:", response.data);
  
      // Fetch table data again
      fetchTables();
      resetForm();
      // Show SweetAlert2 success notification
      Swal.fire({
        icon: "success",
        title: "Slot Created!",
        text: "The slot has been created successfully.",
        confirmButtonText: "OK",
      });
  
      setCreate(false); // Close modal
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
  
      // Show SweetAlert2 error notification
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: `${error.response.data.error}`,
        confirmButtonText: "OK",
      });
    } finally {
      setPostloading(false);
    }
  };
  const resetForm = () => {
    setFormData({
      slot_name: "",
      slot_description: "",
      slot_image: "",
      from_time: "",
      to_time: "",
    });
    setCreate(false);
  };
  

    //reset the values
    const handleToReset = () => {
         // Reset the form fields individually
         setFormData({
          ...formData,
          e_name: " ", 
  e_email: "", 
  e_password:" ",
  e_phone:"",
  e_role:"",
  profile:null
      });
    }

    //Go to home page
    const handleButtonClick = () => {
      history.push('/AdminHome')
    }



      

     //delete method for remove UOM
     const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };

    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}slot-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Slot removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Employee not found");
            Swal.fire("Error", "Employee not found!", "error");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire("Error", `${error.response.data.error}`, "error");
        });
    };
    


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          e_name: data.e_name, 
          e_email: data.e_email, 
          e_password: data.e_password,
          e_phone: data.e_phone,
          e_role: data.e_role,
          profile: data.e_profile,
          shops: data.shops
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};

//onchange function for file 
const handleImageUpdateChange = (e) => {
  const file = e.target.files[0];
  console.log("file",file)
  setUpdateFormData({ ...updateformData, profile: file });
};


 // Function to handle update checkbox change
 const handleUpdateCheckboxChange = (index) => {
  const updatedShops = [...updateformData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };
  console.log("upd",updatedShops);

  setUpdateFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


//update method for employee
//post method for updating the food
const handleUpdateSubmit = async (e) => {
  e.preventDefault();  
  console.log("updateformData",updateformData);
 
  
  const camelCaseEName = capitalize(updateformData.e_name);

  const formDataToSend = new FormData();
  formDataToSend.append('e_name', camelCaseEName);
  formDataToSend.append('e_email', updateformData.e_email);
  formDataToSend.append('e_password', updateformData.e_password);
  formDataToSend.append('e_phone', updateformData.e_phone);
  formDataToSend.append('e_role', updateformData.e_role);
  formDataToSend.append('profile', updateformData.profile); 

   // Append shop data (if any)
   updateformData.shops.forEach((shop, index) => {
    formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
    formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
    formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
  });
  

   try {
    const response = await fetch(`${var_api}/api/employees/emp-put/${updateformData.id}`, {
      method: 'PUT',
    body: formDataToSend,
  });
    if(response.status == 200){
      fetchTables();
      setIsEdit(false);
      Swal.fire({
        title: 'Success',
        text: 'Employee Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
      
      const data = await response.json();
      console.log('Registration successful!',data);
   
    }else {
      console.error('Failed to Update Food:', response.statusText);
      // Handle error, e.g., show an error message to the user
      Swal.fire({
        title: 'error',
        text: 'Failed to Update Food...Please Try Again!',
        icon: 'error',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
    
    // Handle success scenario as needed
  } catch (error) {
      console.error('Error:', error);
      // Handle error scenario as needed
    }
  };

  const handleToggle = (isChecked, item) => {
    const formData = new FormData();
formData.append('shop_id', item.shop_id);
formData.append('slot_name', item.slot_name);
formData.append('slot_image', item.slot_image);
formData.append('is_active', isChecked ? 1 : 0);
formData.append('slot_description', item.slot_description); // File from input
formData.append('from_time', item.from_time);
formData.append('to_time', item.to_time);
formData.append('advance_hrs_for_booking', item.advance_hrs_for_booking);

    // const updatedData = {
    //   shop_id: item.shop_id,
    //   category_name: item.category_name,
    //   category_image: item.category_image,

    //   category_code: item.category_code,
    //   is_active: isChecked ? 1 : 0, // Convert boolean to 1 or 0
    // };
    const token=localStorage.getItem('Token');
    axios
      .put(`${var_api}slot-master/put/${item.id}`, formData,{
        headers:{
          Authorization:`${token}`
        }}
      )
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Category status updated successfully!", "success");
            fetchTables();
       
        } else {
          Swal.fire("Error", "Failed to update category status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", `${error.response.data.error}`, "error");
      });
  };
  


    return(
      <>         <Layout>

       
            <div class="splitsc">
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Slot</Button>{' '} */}
    
    <div>
  
   
     <div class="row">
     <div class="col">
         <h4 className='ushe'>CREATE SLOT</h4>
         </div>
         <div class="col">
       <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Slot</Button>{' '}
       <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
       </div>
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
      <table className="table table-hover small-first-col" style={{ border: "none", borderColor: "grey", width: "90%", margin: "auto" }}>
        <thead>
          <tr style={{ fontWeight: "bolder" }}>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">S.No</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Slot Name</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Slot Description</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">From Time</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">To Time</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Advance Hours</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Status</th>
            <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Action</th>
          </tr>
        </thead>
        {loading ? (
          <div className="loader-containeru">
            <div className="spinneru"></div>
          </div>
        ) : (
          <tbody className="body-half-screen">
            {currentTables.length === 0 ? (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "gray" }}>
                  No data available
                </td>
              </tr>
            ) : (
              currentTables.map((item, index) => (
                <tr key={item.id} style={{ padding: "4px" }}>
                  <th scope="row">{index + 1}</th>
                  <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                  <img src={item.slot_image ? `${image_api}/${item.slot_image}` : dummyimg} alt="profile" style={{ width: '75px', height: '65px', objectFit: 'cover' }} 
                    onError={(e) => {
                      e.target.onerror = null; // prevent infinite loop
                      e.target.src = dummyimg;
                    }}/>
                    {item.slot_name}</td>
                  <td style={{ textAlign: "left" }}>{item.slot_description}</td>
                  <td style={{ textAlign: "left" }}>{item.from_time}</td>
                  <td style={{ textAlign: "left" }}>{item.to_time}</td>
                  <td style={{ textAlign: "left" }}>{item.advance_hrs_for_booking}</td>
                  <td style={{ textAlign: "left" }}>
                    <div className="form-check form-switch" style={{ display: "flex", justifyContent: "left" }}>
                    <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, item)}
            />
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <i className="bi bi-pencil-square"  onClick={() => handleEditCategory(item)} style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}></i>{' '}
                    <i className="bi bi-trash"  onClick={() => handleDeleteEmployeee(item.id)} style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}></i>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        )}
      </table>

      <Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={filteredTables.length}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
  show={show}
  onHide={() => setShow(false)}
  backdrop="static"
  keyboard={false}
  size="md" // Set size to medium
>
  <Modal.Header style={{ padding: "3px", backgroundColor: "green" }}>
    <Modal.Title style={{ fontSize: "20px" }}></Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ padding: "20px" }}>
      <h6 className="text-dark" style={{ textAlign: "center", fontWeight: "bolder" }}>
        Are you sure you want to delete the Slot Name
        <span style={{ color: "red", textTransform: "uppercase" }}>
          
        </span>
        ?
      </h6>
    </div>
    <Button variant="danger" style={{ float: "right" }} onClick={() => setShow(false)}>
      Close
    </Button>
    {' '}
    <Button variant="success" style={{ float: "right", marginRight: "5px" }} onClick={handleDelete}>
      Confirm
    </Button>
  </Modal.Body>
</Modal>


<Modal
  show={isEditModalOpen}
  onHide={() => setEditModalOpen(false)}
  backdrop="static"
  keyboard={false}
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Edit Slot</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <form className="py-2" onSubmit={handleEditSubmit}>
      <div className="row">
        <div className="col">
          <label
            htmlFor="input1"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            Slot Name
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Enter Slot Name"
            name="slot_name"
            value={editFormData.slot_name}
            onChange={handleEditInputChange}
            style={{ borderRadius: "15px", height: "50px" }}
            required
          />
        </div>
        <div className="col">
          <label
            htmlFor="input2"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            Slot Description
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInput"
            placeholder="Enter Slot Description"
            name="slot_description"
            value={editFormData.slot_description}
            onChange={handleEditInputChange}
            style={{ borderRadius: "15px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <label
            htmlFor="input5"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            Slot Image
          </label>
          <input
            type="file"
            className="form-control"
            id="formFile"
            onChange={handleEditImageChange}
            style={{ borderRadius: "15px", height: "50px" }}
          />
        </div>
        <div className="col">
          <label
            htmlFor="input5"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            From Time
          </label>
          <input
            type="time"
            className="form-control"
            name="from_time"
            value={editFormData.from_time}
            onChange={handleEditInputChange}
            style={{ borderRadius: "15px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col">
          <label
            htmlFor="input5"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            To Time
          </label>
          <input
            type="time"
            className="form-control"
            name="to_time"
            value={editFormData.to_time}
            onChange={handleEditInputChange}
            style={{ borderRadius: "15px", height: "50px" }}
            required
          />
        </div>
        <div className='col'>
        <label
            htmlFor="input5"
            style={{
              color: "green",
              fontFamily: "serif",
              fontWeight: "bolder",
            }}
          >
            Advance Hours
          </label>
          <input
            type="number"
            className="form-control"
            name="advance_hrs_for_booking"
            value={editFormData.advance_hrs_for_booking}
            onChange={handleEditInputChange}
            style={{ borderRadius: "15px", height: "50px" }}
            required
          />
        </div>
      </div>
      <br />
      <div className="text-center">
        {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          <button
            className="btn btn-success"
            style={{ borderRadius: "15px", float: "right", marginTop: "6px" }}
            disabled={postloading}
          >
            Update
          </button>
        )}
      </div>
    </form>
    <button
      className="btn btn-danger"
      onClick={() => setEditModalOpen(false)}
      style={{ borderRadius: "15px", float: "right", marginRight: "5px" }}
    >
      Cancel
    </button>
  </Modal.Body>
</Modal>


      <Modal
      show={isCreate}
      onHide={() => setCreate(false)}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Slot</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="py-2" onSubmit={Submit}>
          <div className="row">
            <div className="col">
              <label
                htmlFor="input1"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                Slot Name
              </label>
              <input
                type="text"
                className="form-control"
                id="floatingInput"
                placeholder="Enter Slot Name"
                name="slot_name"
                value={formData.slot_name}
                onChange={handleInputChange}
                style={{ borderRadius: "15px", height: "50px" }}
                required
              />
            </div>
            <div className="col">
              <label
                htmlFor="input2"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                Slot Description
              </label>
              <input
                type="text"
                className="form-control"
                id="floatingInput"
                placeholder="Enter Slot Description"
                name="slot_description"
                value={formData.slot_description}
                onChange={handleInputChange}
                style={{ borderRadius: "15px", height: "50px" }}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col">
              <label
                htmlFor="input5"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                Slot Image
              </label>
              <input
                type="file"
                className="form-control"
                id="formFile"
                onChange={handleImageChange}
                style={{ borderRadius: "15px", height: "50px" }}
              />
            </div>
            <div className="col">
              <label
                htmlFor="input5"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                From Time
              </label>
              <input
                type="time"
                className="form-control"
                name="from_time"
                value={formData.from_time}
                onChange={handleInputChange}
                style={{ borderRadius: "15px", height: "50px" }}
                required
              />
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col">
              <label
                htmlFor="input5"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                To Time
              </label>
              <input
                type="time"
                className="form-control"
                name="to_time"
                value={formData.to_time}
                onChange={handleInputChange}
                style={{ borderRadius: "15px", height: "50px" }}
                required
              />
            </div>
            <div className='col'>
            <label
                htmlFor="input5"
                style={{
                  color: "green",
                  fontFamily: "serif",
                  fontWeight: "bolder",
                }}
              >
                Advance Hours
              </label>
              <input
                type="number"
                className="form-control"
                name="advance_hrs_for_booking"
                value={formData.advance_hrs_for_booking}
                onChange={handleInputChange}
                style={{ borderRadius: "15px", height: "50px" }}
                required
              />
            </div>
          </div>
          <br />
          <div className="text-center">
            {postloading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <button
                className="btn btn-success"
                style={{ borderRadius: "15px", float: "right", marginTop: "6px" }}
                disabled={postloading}
              >
                Create
              </button>
            )}
          </div>
        </form>
        <button
          className="btn btn-danger"
          onClick={() => resetForm()}
          style={{ borderRadius: "15px", float: "right", marginRight: "5px" }}
        >
          Cancel
        </button>
      </Modal.Body>
    </Modal>


            {/* </div> */}
       </Layout></>

        
    )
}

export default SlotCreation;